export enum ErrorGaPageName {
  Generic = 'generic-error',
}
